import React from "react";
import { Link, useLocation, matchPath } from "react-router-dom";
import PropTypes from "prop-types";
import routesConfig from "../../../utils/routesConfig";
import "./Breadcrumbs.css";

const Breadcrumbs = ({ customTrail = null, customLinks = [] }) => {
  const location = useLocation();
  const pathnames = location.pathname.split("/").filter(Boolean);
  const seen = new Set();

  // Define paths where breadcrumbs should not be clickable
  const nonClickablePaths = [
    "/auth",
    "/auth/login/awaiting-link",
    "/auth/signup",
    "/auth/signup/verify",
    "/auth/password",
    "/auth/password/verify",
    "/__/auth/action",
  ];

  const generateBreadcrumbs = () => {
    const crumbs = [];
    let cumulativePath = "";

    for (let i = 0; i < pathnames.length; i++) {
      const currentSegment = pathnames[i];
      const currentPath = `${cumulativePath}/${currentSegment}`;
      cumulativePath = currentPath;

      const matchedRoute = routesConfig.find(route =>
        matchPath({ path: route.path, end: true }, currentPath)
      );

      if (!matchedRoute) continue;

      const name = matchedRoute.breadcrumb;
      if (!name || seen.has(name)) continue;

      seen.add(name);
      crumbs.push({ name, path: currentPath });
    }

    return crumbs;
  };

  const crumbs = generateBreadcrumbs();

  return (
    <nav className="breadcrumbs" aria-label="breadcrumb">
      {crumbs.length > 0 && <Link to="/">முகப்பு</Link>}

      {crumbs.map((crumb) => (
        <span key={crumb.path}>
          {" > "}
          {nonClickablePaths.includes(crumb.path) ? (
            <span>{crumb.name}</span>
          ) : (
            <Link to={crumb.path}>{crumb.name}</Link>
          )}
        </span>
      ))}

      {customLinks.map((link) => (
        <span key={link.path}>
          {" > "}
          {link === customLinks[customLinks.length - 1] ? (
            <span>{link.name}</span>
          ) : (
            <Link to={link.path}>{link.name}</Link>
          )}
        </span>
      ))}

      {customTrail && !customLinks.length && (
        <span>
          {" > "}
          <span>{customTrail}</span>
        </span>
      )}
    </nav>
  );
};

Breadcrumbs.propTypes = {
  customTrail: PropTypes.string,
  customLinks: PropTypes.arrayOf(
    PropTypes.shape({
      path: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired
    })
  )
};

export default Breadcrumbs;
